import * as fromDatatype from '../datatype-library/index';

export interface bl_cms_website_user_agreement_consent_history_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    login_subject_guid: fromDatatype.GuidDataFieldInterface;
    user_agr_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_type: fromDatatype.VarcharArrayDatatypeInterface;
    consent_method: fromDatatype.VarcharArrayDatatypeInterface;
    ip_address: fromDatatype.VarcharArrayDatatypeInterface;
    browser_agent: fromDatatype.VarcharArrayDatatypeInterface;
    esignature: fromDatatype.VarcharArrayDatatypeInterface;
    cookies: fromDatatype.VarcharArrayDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharArrayDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharArrayDatatypeInterface;
    member_id: fromDatatype.VarcharArrayDatatypeInterface;
    email: fromDatatype.VarcharArrayDatatypeInterface;
    phone_no: fromDatatype.VarcharArrayDatatypeInterface;
}

export class bl_cms_website_user_agreement_consent_history_RowClass implements bl_cms_website_user_agreement_consent_history_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    login_subject_guid: fromDatatype.GuidDataFieldInterface;
    user_agr_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_type: fromDatatype.VarcharArrayDatatypeInterface;
    consent_method: fromDatatype.VarcharArrayDatatypeInterface;
    ip_address: fromDatatype.VarcharArrayDatatypeInterface;
    browser_agent: fromDatatype.VarcharArrayDatatypeInterface;
    esignature: fromDatatype.VarcharArrayDatatypeInterface;
    cookies: fromDatatype.VarcharArrayDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharArrayDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharArrayDatatypeInterface;
    member_id: fromDatatype.VarcharArrayDatatypeInterface;
    email: fromDatatype.VarcharArrayDatatypeInterface;
    phone_no: fromDatatype.VarcharArrayDatatypeInterface;
}